import React from "react";
import { CheckIcon, GlobeIcon } from "lucide-react";
import { Section } from "./Section";
import { collectionItems } from "../data/landing";
export function CollectionSummary() {
  return <Section tone="navy" cta="Get Instant Access" data-id="element-80" data-mp="29oc0rc0dm1lj">
      <div className="grid items-center gap-10 lg:grid-cols-2" data-id="element-81" data-mp="29n21ijhsendb">
        <div className="text-center lg:text-left" data-id="element-82" data-mp="25m8c1lop50ib">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold sm:text-sm" data-id="element-83" data-mp="25pmdmrpjd5op">
            Your complete digital collection
          </p>
          <h2 className="mt-4 font-serif text-[2rem] font-bold leading-[1.12] text-cream sm:text-5xl" data-id="element-84" data-mp="1vwfaldi9q1rs">
            HOF CLINICAL BLUEPRINT™
          </h2>
          <p className="mt-5 text-base leading-relaxed text-muted sm:text-lg" data-id="element-85" data-mp="1lzaofdofa6az">
            A practical educational library for facial aesthetic professionals who want a more organized approach to
            clinical safety.
          </p>
          <div className="mt-8 inline-flex flex-col items-center rounded-2xl bg-ink px-8 py-5 ring-1 ring-gold/40 lg:items-start" data-id="element-86" data-mp="1cznlgng1osft">
            <span className="font-serif text-5xl font-extrabold text-gold" data-id="element-87" data-mp="1vgh5x4gw881p">$27 USD</span>
            <span className="mt-1 text-sm font-bold uppercase tracking-widest text-cream" data-id="element-88" data-mp="20a35pw1ykhg3">One-time payment</span>
          </div>
        </div>

        <div data-id="element-89" data-mp="1qip33fepn1iq">
          <ul className="divide-y divide-line rounded-2xl bg-ink ring-1 ring-line" data-id="element-90" data-mp="1qi778jvympbc">
            {collectionItems.map(item => <li key={item} className="flex items-center gap-4 px-5 py-4 sm:px-6" data-id="element-91" data-mp="2e9l0cs1xqoxd">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gold text-ink" data-id="element-92" data-mp="2j6bf9c207eh7">
                  <CheckIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-93" data-mp="256tows927t5q" />
                </span>
                <span className="text-base font-semibold text-cream sm:text-lg" data-id="element-94" data-mp="2a54z5439o5oh">{item}</span>
              </li>)}
          </ul>
          <p className="mt-4 flex items-start gap-2 text-sm leading-snug text-muted" data-id="element-95" data-mp="yrj5p6qdjhx5">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-96" data-mp="yp6jghdl2lea" />
            Your currency may be converted automatically according to your country and payment provider.
          </p>
        </div>
      </div>
    </Section>;
}